module.exports = __webpack_public_path__ + "static/21-2e52048c4da22d3f72db747a25a8c2ff.png";